export default __webpack_public_path__ + "static/Entenda0146-dda07e1de827a53ac4ee2b624540c348.jpg";